import React, { createContext, useContext } from 'react';

export const Container = {
  createContainer<State, Init = Record<string, string>>(fn: (init: Init) => State) {
    const Ctx = createContext<State | null>(null);
    const Provider = ({ value = {} as Init, children }: { value?: Init; children?: React.ReactNode }) => {
      const store = fn(value);
      return <Ctx.Provider value={store}>{children}</Ctx.Provider>;
    };
    const useContainer = (): State => {
      const ctx = useContext(Ctx);
      if (!ctx) {
        throw new Error('Container provider missing');
      }
      return ctx;
    };
    return { Provider, useContainer };
  },
};
